import React from "react";

import aerodynamics from "../img/about/aero.png";
import avionics from "../img/about/avionics.jpg";
import composites from "../img/about/composites.jpg";
import hardware from "../img/about/hardware.jpg";
import manufacturing from "../img/about/manufacturing.jpg";
import propulsion from "../img/about/propulsion.jpg";
import software from "../img/about/software.jpg";
import structures from "../img/about/structures.png";

const subteams = [
  {
    name: "Aerodynamics",
    image: aerodynamics,
    description: (
      <>
        The Aerodynamics subteam is the fundamental design area for M-Fly. The
        subteam works to design an aircraft that can carry the appropriate
        payload, take off within runway constraints, and complete the mission
        successfully.
      </>
    ),
    link: "https://drive.google.com/drive/folders/1rRe2LD5Nd2bD6wbXgF06uVxVWuPL2XqG",
  },
  {
    name: "Propulsion",
    image: propulsion,
    description: (
      <>
        The Propulsion subteam is responsible for selecting and testing the
        optimal motor-propeller combination which will provide the aircraft with
        enough thrust to complete its mission while still remaining within the
        competition power constraints.
      </>
    ),
    link: "https://docs.google.com/document/d/15ASgZEOPBvGdoNcvuxkRKKt5ji2Jv01HXJG6AhABPUc/edit?tab=t.0",
  },
  {
    name: "Structures",
    image: structures,
    description: (
      <>
        The Structures subteam is responsible for the mechanical design of the
        aircraft and ensures the system can handle all flight loads predicted by
        the Aerodynamics subteam.
      </>
    ),
    link: "https://docs.google.com/document/d/1dkLmm-sd8JX1tEihagQeyBGdrSUsznFP/edit?usp=sharing&ouid=105162077265922978634&rtpof=true&sd=true",
  },
  {
    name: "Software",
    image: software,
    description: (
      <>
        The Software subteam is reponsible
        for all software on the aircraft, and develops the algorithms that allow
        the aircraft to autonomously navigate waypoints and detect and classify targets.
      </>
    ),
    link: "https://docs.google.com/document/d/1ECvziHqzRF6WAWZi2BTU9_zY99rmenyxZIKhxIxQK9g/edit?usp=sharing"
  },
  {
    name: "Hardware",
    image: hardware,
    description: (
      <>
        The Hardware team works on the Autonomous aircraft's electronics. They
        are responsible for the hardware that handles autonomy, computer vision,
        and other aspects of the aircraft's control system. 
      </>
    ),
    link: "https://docs.google.com/document/d/1ge8-gMwuFReYmk44VLkELxVJvwV3XjVI9j-WBnXn0pA/edit?usp=sharing"
  },
  {
    name: "Manufacturing",
    image: manufacturing,
    description: (
      <>
        The Manufacturing subteam takes the computerized aircraft design and
        builds it from the ground up. In addition to wood, we
        work with carbon fiber and fiberglass and design and manufacture many of
        our own molds.
      </>
    ),
    link: "https://drive.google.com/file/d/12idmcS--i-5ntecf0DnaCOOMIYfJ07yh/view?usp=sharing"
  },
];

export default subteams;
